// deploy-pipelines-list-payload — flattens each PipelineGroupDto's Pipelines into one row
// set, carrying the owning App Instance's Id/Name straight from the payload (AC-1/AC-7/
// AC-8: no more client-resolved bulk app-instances lookup). AppInstanceName is passed
// through exactly as the server resolved it — a real name, or `null` when the owning App
// Instance is soft-deleted/absent (OQ-5/AC-11). Rendering the literal `(deleted)` marker
// for a null value is a presentation concern handled by the column's renderCell, not this
// pure data-shaping helper.
export const flattenPipelineGroups = (groups = []) =>
  (groups ?? []).flatMap(group =>
    (group?.Pipelines ?? []).map(pipeline => ({
      ...pipeline,
      AppInstanceId: group?.AppInstanceId,
      AppInstanceName: group?.AppInstanceName ?? null,
    }))
  );

export default flattenPipelineGroups;
